import { render } from "./TribesDiscussionList.vue?vue&type=template&id=6c25ef08&ts=true"
import script from "./TribesDiscussionList.vue?vue&type=script&lang=ts"
export * from "./TribesDiscussionList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__